'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DOWNLOAD_DELAY = exports.DOWNLOAD_DELAY = 200;
var SHOW_DELAY = exports.SHOW_DELAY = 300;
var HIDE_DELAY = exports.HIDE_DELAY = 150;
var API = exports.API = '//iknow.jp/api/sentence_dictionary';
var FEEDBACK_URL = exports.FEEDBACK_URL = 'http://iknow.jp/dictionary_entry_feedbacks/new';
var AUTOSCAN_CLASS = exports.AUTOSCAN_CLASS = 'iknow-dictionary-here';
var POPUP_CLASS = exports.POPUP_CLASS = 'iknow-dictionary-target';
var BUTTON_CLASS = exports.BUTTON_CLASS = 'iknow-dictionary-button';
var BUTTON_RESTING_OPACITY = exports.BUTTON_RESTING_OPACITY = '0.4'; // Accommodates for rounded corners on the box

var ARROW_SAFETY_MARGIN = exports.ARROW_SAFETY_MARGIN = 12;